// Add Best Value badge to subscription option only
function addBestValueBadge() {
  // Find all option containers
  const optionContainers = document.querySelectorAll('.seal-row, [data-selling-plan-group]');
  
  optionContainers.forEach((container) => {
    // Find the label within this container
    const label = container.querySelector('.sls-selling-plan-group-name');
    
    if (!label) return;
    
    // Skip if badge already exists
    if (label.querySelector('.best-value-badge')) return;
    
    // Get the text content
    const text = label.textContent.toLowerCase().trim();
    
    // Check if this is a subscription (not one-time purchase)
    const isSubscription = !text.includes('one-time') && 
                          (text.includes('refill') || 
                           text.includes('subscription') || 
                           text.includes('starter kit'));
    
    if (isSubscription) {
      const badge = document.createElement('span');
      badge.className = 'best-value-badge';
      badge.textContent = 'BEST VALUE';
      badge.style.cssText = `
        display: inline-block !important;
        padding: 4px 10px !important;
        margin-left: 8px !important;
        background: rgba(22, 162, 255, 0.15) !important;
        backdrop-filter: blur(7px) !important;
        -webkit-backdrop-filter: blur(7px) !important;
        border: 2px solid #16A2FF !important;
        border-radius: 6px !important;
        font-size: 11px !important;
        font-weight: 900 !important;
        color: #000000 !important;
        text-transform: uppercase !important;
        letter-spacing: 0.5px !important;
        box-shadow: 0 2px 8px rgba(22, 162, 255, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.5) !important;
        white-space: nowrap !important;
        vertical-align: middle !important;
        position: relative !important;
        z-index: 999 !important;
      `;
      label.appendChild(badge);
    }
  });
}

// Debounce function to prevent excessive calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Debounced version - only runs once after changes stop for 300ms
const debouncedAddBadge = debounce(addBestValueBadge, 300);

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(addBestValueBadge, 600);
  });
} else {
  setTimeout(addBestValueBadge, 600);
}

// Watch for Seal widget initialization (one-time)
setTimeout(function() {
  const subscriptionContainer = document.querySelector('.sls-option-container, .seal-table');
  
  if (subscriptionContainer) {
    // Use debounced version to prevent spam
    const observer = new MutationObserver(debouncedAddBadge);
    
    observer.observe(subscriptionContainer, {
      childList: true,
      subtree: false  // Only watch direct children, not deep changes
    });
  }
}, 1000);

// Watch for variant changes only (debounced)
document.addEventListener('change', function(e) {
  if (e.target.matches('select[name="id"]')) {
    debouncedAddBadge();
  }
});